type Point = number[];

/**
 * Visvalingam & Whyatt style line simplification, as applied to traced contours when saving.
 *
 * This is a copy of the simplification loop in Sdf.getContours(), used for checking contours as they would be saved
 * without going through the save path itself. Keep the two in sync.
 */
export function simplifyTracedPolygon(polygon: Point[]): Point[] {
    const triangleAreaTreshold = Math.min(0.1 * polygon.length / 200, 0.8);

    let keptRatio = 0;
    while (keptRatio < 0.97) {
        const newPoly: Point[] = [];
        for (let i = 0; i < polygon.length; i += 2) {
            newPoly.push(polygon[i]);
            if (i === polygon.length - 1) { break; }
            if (i === polygon.length - 2) {
                newPoly.push(polygon[i + 1]);
                break;
            }
            // calculate the area of the triangle formed by three consecutive points in the polygon
            // A = | (Ax * (By - Cy) + Bx * (Cy - Ay) + Cx * (Ay - By)) / 2 |;
            if (Math.abs(
                    (polygon[i][0] * (polygon[i + 1][1] - polygon[i + 2][1])
                    + polygon[i + 1][0] * (polygon[i + 2][1] - polygon[i][1])
                    + polygon[i + 2][0] * (polygon[i][1] - polygon[i + 1][1])
                    ) / 2) > triangleAreaTreshold) {
                newPoly.push(polygon[i + 1]);
            }
        }
        keptRatio = newPoly.length / polygon.length;
        polygon = newPoly;
    }
    return polygon;
}
